import { useCallback } from "react";
import { showNotification } from "@/components/alerts/Notifications";
import { ALLOWED_NICHES, MAX_NICHES_MESSAGE, NOT_AVAILABLE_MESSAGE } from "./constants";
import { IOnChangeCheckBox, INicheOption } from "../../popups/AddToNichePopup/types";

type TUseChangeOption = {
  nicheFields: INicheOption[];
  onUpdateNiches: (fields: INicheOption[]) => void;
}

export const useChangeOption = ({
  nicheFields,
  onUpdateNiches,
}: TUseChangeOption) => {
  const handleAvailableMessage = useCallback(() => {
    showNotification({
      title: NOT_AVAILABLE_MESSAGE,
      variant: "info"
    });
  }, []);

  const handleRichLimitMassage = useCallback(() => {
    showNotification({
      title: MAX_NICHES_MESSAGE,
      variant: "info"
    });
  }, []);

  const handleCheckBoxChange = useCallback(({ index }: Omit<IOnChangeCheckBox, "available">) => {
    const fields = [...nicheFields];
    const currentField = fields.find(niche => niche.id === index);
    const checkedQty = fields.filter(niche => niche.isChecked);

    if (!currentField) {
      return;
    }

    if (checkedQty.length >= ALLOWED_NICHES && !currentField?.isChecked) {
      return handleRichLimitMassage();
    }

    currentField.isChecked = !currentField.isChecked;

    onUpdateNiches(fields);
  }, [nicheFields, onUpdateNiches]);

  const handleOptionChange = useCallback(({
    index,
    available = true
  }: IOnChangeCheckBox) => {
    if (!available) {
      handleAvailableMessage();
    } else {
      handleCheckBoxChange({ index });
    }
  }, [handleAvailableMessage, handleCheckBoxChange]);

  return {
    handleOptionChange
  };
};
